// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3FTCO","content":"LoadingAlert_content__2GpT6"};